/**
 * ChannelStatusPage — the entry point for Mail, Sync and Outbound.
 *
 * Every visit shows the product intro/SSO handoff (`SuiteExplainer`).
 * Returning visitors fast-path straight through SSO with a loader; there is
 * no separate post-intro status view.
 */
import { SuiteExplainer } from "@/components/suite/SuiteExplainer";
import type { ExplainerDeck } from "@/components/suite/SuiteExplainer";

interface ChannelStatusPageProps {
  /** Suite app id — "mail" | "sync" | "outbound". Resolves wiring from navConfig. */
  appId: string;
  /** The product story. */
  deck: ExplainerDeck;
}

const ChannelStatusPage = ({ appId, deck }: ChannelStatusPageProps) => (
  <SuiteExplainer appId={appId} deck={deck} />
);

export default ChannelStatusPage;
